import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FeaturedContent from '../pages/index';
import CreateFeaturedContent from '../pages/create';
import FeaturedContentDetail from '../pages/detail';
import EditFeaturedContent from '../pages/edit';
import DefaultLayout from '../../../layouts/default';
import PrivateOutlet from '../../../components/PrivateOutlet';
import { RouteNameEnum } from '../../../enums/routeName';
import { PermissionEnum } from '../../../enums/permission';

const routes = [
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.featuredContentViewList],
    },
    routeProperties: {
      path: RouteNameEnum.featuredContent.index,
      element: <FeaturedContent />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.featuredContentCreate],
      redirectUrl: RouteNameEnum.featuredContent.index,
    },
    routeProperties: {
      path: RouteNameEnum.featuredContent.create,
      element: <CreateFeaturedContent />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.featuredContentViewList],
      redirectUrl: RouteNameEnum.featuredContent.index,
    },
    routeProperties: {
      path: RouteNameEnum.featuredContent.detail,
      element: <FeaturedContentDetail />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.featuredContentEdit],
      redirectUrl: RouteNameEnum.featuredContent.index,
    },
    routeProperties: {
      path: RouteNameEnum.featuredContent.edit,
      element: <EditFeaturedContent />,
    },
  },
];

const BaseRoutes: React.FC = () => (
  <Routes>
    <Route element={<DefaultLayout />}>
      {routes.map((route) => (
        <Route key={route.routeProperties.path} element={<PrivateOutlet {...route.privateProperties} />}>
          <Route key={`inner-${route.routeProperties.path}`} {...route.routeProperties} />
        </Route>
      ))}
    </Route>
  </Routes>
);

export default BaseRoutes;
